import { Laya } from "../../../../../Laya";
import { Laya3DRender } from "../../../../d3/RenderObjs/Laya3DRender";
import { Transform3D } from "../../../../d3/core/Transform3D";
import { BoundsImpl } from "../../../../d3/math/BoundsImpl";
import { WebBaseRenderNode } from "./WebBaseRenderNode";
import { WebDirectLight } from "./WebDirectLight";
import { WebLightmap } from "./WebLightmap";
import { WebMeshRenderNode } from "./WebMeshRenderNode";
import { WebCameraNodeData, WebSceneNodeData } from "./WebModuleData";
import { WebPointLight } from "./WebPointLight";
import { WebReflectionProbe } from "./WebReflectionProb";
import { WebSkinRenderNode } from "./WebSkinRenderNode";
import { WebSpotLight } from "./WebSpotLight";
import { WebVolumetricGI } from "./WebVolumetricGI";
import { WebSimpleSkinRenderNode } from "./WebSimpleSkinRenderNode";
export class Web3DRenderModuleFactory {
    createSimpleSkinRenderNode() {
        return new (WebSimpleSkinRenderNode())();
    }
    createTransform(owner) {
        return new Transform3D(owner);
    }
    createBounds(min, max) {
        return new BoundsImpl(min, max);
    }
    createVolumetricGI() {
        return new WebVolumetricGI();
    }
    createReflectionProbe() {
        return new WebReflectionProbe();
    }
    createLightmapData() {
        return new WebLightmap();
    }
    createDirectLight() {
        return new WebDirectLight();
    }
    createSpotLight() {
        return new WebSpotLight();
    }
    createPointLight() {
        return new WebPointLight();
    }
    createCameraModuleData() {
        return new WebCameraNodeData();
    }
    createSceneModuleData() {
        return new WebSceneNodeData();
    }
    createBaseRenderNode() {
        let renderNode = new WebBaseRenderNode();
        return renderNode;
    }
    createMeshRenderNode() {
        return new (WebMeshRenderNode())();
    }
    createSkinRenderNode() {
        return new (WebSkinRenderNode())();
    }
}
Laya.addBeforeInitCallback(() => {
    if (!Laya3DRender.Render3DModuleDataFactory) {
        Laya3DRender.Render3DModuleDataFactory = new Web3DRenderModuleFactory();
    }
});
